import classNames from 'classnames';
import { RichTextEditor } from '../RichTextEditor';
import styles from './RichTextValue.module.scss';

export interface RichTextValueProps {
  label: string | false;
  className?: string;
  labelClassName?: string;
  value?: string;
  ownerId?: string;
  ownerType: string;
}

export function RichTextValue(props: RichTextValueProps) {
  const { label, className, labelClassName, value } = props;
  return (
    <div className={classNames(className, styles.container)}>
      {label && (
        <div className={classNames(labelClassName, styles.label)}>{label}</div>
      )}
      {
        <div className={styles.value}>
          {value && (
            <RichTextEditor
              value={value}
              disabled={true}
              readonly={true}
              bordered={false}
              ownerId={props.ownerId}
              ownerType={props.ownerType}
            />
          )}
        </div>
      }
    </div>
  );
}
